
/**
 *  判断是否有可用关键字
 */
export function hasTag(keywords, diseaseName) {
  // 如果keywords只包含一个keyword，且该keyword为病种名，则不显示“猜您想问”
  return keywords !== null && keywords.length > 0 && (keywords.length > 1 || keywords[0].name != diseaseName);
}

/**
 *  监控iframe内部点击事件（跨域）
 *  eg: iFrameOnClickHandler.track(document.getElementById("iFrame"), function() { do something... });
 **/
export const iFrameOnClickHandler = {
  resolution: 200,
  iframes: [],
  interval: null,
  Iframe: function() {
    this.element = arguments[0];
    this.cb = arguments[1];
    this.hasTracked = false;
  },
  track: function(element, cb) {
    this.iframes.push(new this.Iframe(element, cb));
    if (!this.interval) {
      let _this = this;
      this.interval = setInterval(function() { _this.checkClick(); }, this.resolution);
    }
  },
  checkClick: function() {
    if (document.activeElement) {
      let activeElement = document.activeElement;
      for (let i in this.iframes) {
        if (activeElement === this.iframes[i].element) { // current iFrame
          if (this.iframes[i].hasTracked === false) {
            console.log(this.iframes[i])
            console.log(this.iframes[i].cb)
            this.iframes[i].cb.apply(window, []);
            this.iframes[i].hasTracked = true;
          }
        } else {
          this.iframes[i].hasTracked = false;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/commonUtil.js